import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-producto',
  templateUrl: './dialog-producto.component.html',
  styleUrls: ['./dialog-producto.component.css']
})
export class DialogProductoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
